import $ from 'jquery';
import '@fancyapps/fancybox';

/*!
 * Examples at http://fancyapps.com/fancybox/
 * License: www.fancyapps.com/fancybox/#license
 * License Name: Tomáš Krejčí
 * License key: 669ff49044a69167735d4c8de99d3a8a
 */

export const init = () => {

	$('[data-fancybox]').fancybox({
		afterShow: function (obj) {
			obj.current.$content.trigger('contentload');
		},
	});

};
